<template>
    <div>

  <!-- HEADER TOGGLE -->
  <div class="header-toggle" :class="{'is-hidden': !showHeader}" @click="showHeader = !showHeader" title="ສະແດງ/ເຊື່ອງ Header">
    <span v-if="showHeader">🔼</span>
    <span v-else>🔽</span>
  </div>

  <!-- HEADER -->
  <header class="app-header" :class="{'header-hidden': !showHeader}">
    <div class="header-top">
      <div class="header-logo">🍱</div>
      <div class="header-title">
        <h1>CCA Form — ການປະເມີນຊຸມຊົນ</h1>
        <p>ໂຄງການອາຫານທ່ຽງໃນໂຮງຮຽນ · School Meal Programme 2025–2029</p>
      </div>
    </div>
    <div class="header-meta">
      <div class="meta-field">
        <label>ຊື່ຜູ້ສຳພາດ:</label>
        <input v-model="meta.interviewer" placeholder="ປ້ອນຊື່...">
      </div>
      <div class="meta-field clickable" @click="openSchoolModal">
        <label>ລະຫັດໂຮງຮຽນ:</label>
        <input v-model="meta.schoolCode" placeholder="ຄລິກເພື່ອເລືອກ..." readonly>
      </div>
      <div class="meta-field clickable" @click="openSchoolModal">
        <label>ຊື່ໂຮງຮຽນ:</label>
        <input v-model="meta.schoolName" placeholder="ຄລິກເພື່ອເລືອກ..." readonly>
      </div>
      <div class="meta-field">
        <label>ວັນທີ:</label>
        <input v-model="meta.date" type="date">
      </div>
      <div class="meta-field">
        <label>ເມືອງ:</label>
        <input v-model="meta.district" placeholder="ເມືອງ...">
      </div>
      <div class="meta-field">
        <label>ຊື່ບ້ານ:</label>
        <input v-model="meta.village" placeholder="ຊື່ບ້ານ...">
      </div>
      <div class="meta-field">
        <label>ລະຫັດບ້ານ:</label>
        <input v-model="meta.villageCode" placeholder="ລະຫັດ...">
      </div>
    </div>
  </header>

  <!-- PROGRESS BAR -->
  <div class="progress-bar-wrap">
    <span class="progress-label">ຄວາມຄືບໜ້າ:</span>
    <div class="progress-track"><div class="progress-fill" :style="{width: progress + '%'}"></div></div>
    <span class="progress-pct">{{ progress }}%</span>
  </div>

  <!-- SECTION TABS -->
  <div class="nav-scroll-wrapper" :class="{'tabs-at-top': !showHeader}">
    <div class="section-nav">
      <button
        v-for="(sec, idx) in sections" :key="idx"
        class="nav-tab"
        :class="{ active: currentSection === idx, done: sectionDone[idx] }"
        @click="goSection(idx)">
        <span class="tab-num">{{ sectionDone[idx] ? '✓' : (idx + 1) }}</span>
        {{ sec.short }}
      </button>
    </div>
  </div>

  <!-- SUBMITTED -->
  <div v-if="submitted" class="main">
    <div class="section-card">
      <div class="submitted-box">
        <div class="submitted-icon">✅</div>
        <h2>ສຳເລັດການສຳພາດແລ້ວ!</h2>
        <p style="margin-bottom:20px">ຂໍ້ມູນຖືກບັນທຶກຮຽບຮ້ອຍ. ຂອບໃຈທ່ານທີ່ໃຫ້ຂໍ້ມູນ.</p>
        <button class="btn btn-primary" @click="resetForm">🔄 ເລີ່ມໃໝ່</button>
      </div>
    </div>
  </div>

  <!-- MAIN FORM -->
  <div v-else class="main" :key="currentSection">

    <!-- ===== SECTION I: ການອະນຸຍາດ ===== -->
    <div v-if="currentSection === 0" class="section-card active-section">
      <div class="section-header" :style="{background: 'linear-gradient(135deg, #1a5276, #154360)'}">
        <span class="section-icon">🔐</span>
        <div class="section-title-wrap">
          <h2>I. ການອະນຸຍາດ</h2>
          <p>ສຳລັບຜູ້ເກັບຂໍ້ມູນ / CM</p>
        </div>
      </div>
      <div class="section-body">
        <div class="consent-box">
          <h3>📝 ບົດເວົ້າແນະນຳໂຕ</h3>
          <p>ສະບາຍດີ. ຂ້າພະເຈົ້າຊື່ ..... ເປັນຜູ້ເກັບກຳຂໍ້ມູນ ທີ່ໂຄງການອາຫານທ່ຽງໃນໂຮງຮຽນ ປີ 2025-2029 ໄດ້ມອບໝາຍມາ. ຂ້າພະເຈົ້າ ມີຄຳຖາມຈຳນວນໜຶ່ງ ກ່ຽວກັບວຽກງານທີ່ ຄພສບ ໄດ້ປະຕິບັດໃນໂຄງການອາຫານທ່ຽງ ນີ້. ຄຳຖາມເຫຼົ່ານີ້ຈະໃຊ້ເວລາປະມານ 45 ນາທີ.</p>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">1.1</span> ເຈົ້າໄດ້ອ່ານບົດເວົ້າແນະນຳໂຕແລ້ວບໍ່?</div>
          <div class="options-list inline-2">
            <label class="opt-item" :class="form.q1_1 === 'yes' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q1_1" value="yes">
              <span class="opt-text">✅ ອ່ານແລ້ວ</span>
            </label>
            <label class="opt-item" :class="form.q1_1 === 'no' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q1_1" value="no">
              <span class="opt-text">❌ ບໍ່ໄດ້ອ່ານ</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">1.2</span> ທ່ານຕົກລົງເຫັນດີທີ່ຈະຕອບຄຳຖາມກ່ຽວກັບວຽກງານຂອງ ຄພສບ ແລະ ໂຄງການອາຫານໃນໂຮງຮຽນບໍ່?</div>
          <div class="options-list inline-2">
            <label class="opt-item" :class="form.q1_2 === 'yes' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q1_2" value="yes">
              <span class="opt-text">✅ ແມ່ນແລ້ວ, ເຫັນດີ</span>
            </label>
            <label class="opt-item" :class="form.q1_2 === 'no' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q1_2" value="no">
              <span class="opt-text">❌ ບໍ່ເຫັນດີ</span>
            </label>
          </div>
          <div v-if="form.q1_2 === 'no'" class="q-note warn" style="margin-top:10px">
            ⚠️ ຫາກຜູ້ຕອບ ບໍ່ເຫັນດີ, ບໍ່ສາມາດດຳເນີນການຕໍ່ໄດ້
          </div>
        </div>
      </div>
    </div>

    <!-- ===== SECTION II: ຂໍ້ມູນປະຊາກອນ ===== -->
    <div v-if="currentSection === 1" class="section-card">
      <div class="section-header" :style="{background: 'linear-gradient(135deg, #117a65, #0e6655)'}">
        <span class="section-icon">👥</span>
        <div class="section-title-wrap">
          <h2>II. ຂໍ້ມູນກ່ຽວກັບປະຊາກອນ</h2>
          <p>Demographics</p>
        </div>
      </div>
      <div class="section-body">
        <div class="question-block">
          <div class="q-label"><span class="q-num">2.1</span> ມີຈັກຄົນ ເຂົ້າຮ່ວມການສົນທະນາຄັ້ງນີ້?</div>
          <input class="form-input form-input-sm" type="number" v-model="form.q2_1" placeholder="ຈຳນວນຄົນ" min="1">
        </div>
        <div class="question-block">
          <div class="q-label"><span class="q-num">2.2</span> ມີຈັກຄົວເຮືອນພາຍໃນບ້ານ?</div>
          <input class="form-input form-input-sm" type="number" v-model="form.q2_2" placeholder="ຈຳນວນຄົວເຮືອນ" min="0">
        </div>
        <div class="question-block">
          <div class="q-label"><span class="q-num">2.3</span> ຈຳນວນປະຊາກອນທັງໝົດໃນບ້ານ</div>
          <input class="form-input form-input-sm" type="number" v-model="form.q2_3" placeholder="ຈຳນວນຄົນ" min="0">
        </div>
        <div class="question-block">
          <div class="q-label"><span class="q-num">2.4</span> ຈຳນວນປະຊາກອນແມ່ຍິງທັງໝົດທີ່ຢູ່ໃນບ້ານ</div>
          <input class="form-input form-input-sm" type="number" v-model="form.q2_4" placeholder="ຈຳນວນແມ່ຍິງ" min="0">
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">2.5</span> ພາສາທີ່ບ້ານນຳໃຊ້ແມ່ນກຸ່ມພາສາໃດເປັນສ່ວນໃຫຍ່?</div>
          <div class="options-list">
            <label v-for="opt in langGroups" :key="opt.val" class="opt-item" :class="form.q2_5 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q2_5" :value="opt.val">
              <span class="opt-text"><strong>{{ opt.label }}</strong> <span style="color:var(--text-muted);font-size:12px">{{ opt.sub }}</span></span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">2.6</span> ຊົນເຜົ່າສ່ວນໃຫຍ່ຂອງບ້ານ</div>
          <input class="form-input" v-model="form.q2_6" placeholder="ລະບຸຊົນເຜົ່າ...">
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">2.7</span> ໃຜມີບົດບາດເປັນຜູ້ນຳພາ ຈັດຕັ້ງປະຕິບັດວຽກອາຫານທ່ຽງໃນໂຮງຮຽນ? <span class="badge badge-info">ເລືອກໄດ້ຫຼາຍ</span></div>
          <div class="options-list">
            <label v-for="opt in leaders" :key="opt.val" class="opt-item" :class="form.q2_7.includes(opt.val) ? 'selected-check' : ''">
              <input type="checkbox" :value="opt.val" v-model="form.q2_7">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
            <label class="opt-item" :class="form.q2_7.includes('other') ? 'selected-check' : ''">
              <input type="checkbox" value="other" v-model="form.q2_7">
              <span class="opt-text">ອື່ນໆ
                <span class="opt-sub" v-if="form.q2_7.includes('other')">
                  <input class="form-input" v-model="form.q2_7_other" placeholder="ລະບຸ...">
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== SECTION III: ຂໍ້ມູນຄວາມສ່ຽງ ===== -->
    <div v-if="currentSection === 2" class="section-card">
      <div class="section-header" :style="{background: 'linear-gradient(135deg, #784212, #6e2f1a)'}">
        <span class="section-icon">⚠️</span>
        <div class="section-title-wrap">
          <h2>III. ຂໍ້ມູນຄວາມສ່ຽງຂອງຊຸມຊົນ</h2>
          <p>Community Risk Information</p>
        </div>
      </div>
      <div class="section-body">

        <div class="question-block">
          <div class="q-label"><span class="q-num">3.1</span> <em>(ສຳລັບຜູ້ເກັບຂໍ້ມູນ/CM: ສັງເກດການ)</em> ເປັນບ້ານທີ່ເຂົ້າເຖິງໃນລະດັບໃດ?</div>
          <div class="q-note warn">ຖ້າ A ຫຼ B ຖາມຕໍ່ຂໍ້ Q3.2 | ຖ້າ C ໃຫ້ຂ້າມໄປ Q3.3</div>
          <div class="options-list">
            <label v-for="opt in accessLevels" :key="opt.val" class="opt-item" :class="form.q3_1 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q3_1" :value="opt.val">
              <span class="opt-text"><strong>{{ opt.val }}.</strong> {{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block" v-if="form.q3_1 === 'A' || form.q3_1 === 'B'">
          <div class="q-label"><span class="q-num">3.2</span> ໝູ່ບ້ານຂອງທ່ານ ສາມາດເຂົ້າເຖິງໄດ້ຕະຫຼອດປີ ຫຼ ເຂົ້າໄດ້ແຕ່ໃນລະດູແລ້ງ?</div>
          <div class="options-list">
            <label v-for="opt in accessYear" :key="opt.val" class="opt-item" :class="form.q3_2 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q3_2" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">3.3</span> ລະດັບຄວາມສະດວກໃນການເຂົ້າເຖິງຂອງບ້ານ</div>
          <div class="options-list">
            <label v-for="opt in transportTypes" :key="opt.val" class="opt-item" :class="form.q3_3 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q3_3" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">3.4</span> ຕະຫຼາດທີ່ໃກ້ທີ່ສຸດຢູ່ຫ່າງໄກປານໃດ?</div>
          <div class="options-list inline-2">
            <label v-for="opt in marketDist" :key="opt.val" class="opt-item" :class="form.q3_4 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q3_4" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">3.5</span> ວິທີການສ້າງລາຍຮັບທີ່ພົບເຫັນຫຼາຍທີ່ສຸດໃນບ້ານ</div>
          <div class="options-list">
            <label v-for="opt in incomeTypes" :key="opt.val" class="opt-item" :class="form.q3_5 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q3_5" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">3.6</span> ວິທີການສ້າງລາຍຮັບປະເພດອື່ນໆ <span class="badge badge-info">ເລືອກໄດ້ຫຼາຍ</span></div>
          <div class="options-list">
            <label v-for="opt in incomeTypes" :key="'sec_'+opt.val" class="opt-item" :class="form.q3_6.includes(opt.val) ? 'selected-check' : ''">
              <input type="checkbox" :value="opt.val" v-model="form.q3_6">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">3.7</span> ຊຸມຊົນນີ້ເຄີຍປະສົບກັບໄພພິບັດບໍ່ ໃນໜຶ່ງປີຜ່ານມາ?</div>
          <div class="q-note">ຖ້າ "ມີ" → ຖາມ Q3.8–Q3.12 | ຖ້າ "ບໍ່ມີ" → ຂ້າມໄປ Q3.13</div>
          <div class="options-list inline-2">
            <label v-for="opt in yesNoUnknown" :key="'37_'+opt.val" class="opt-item" :class="form.q3_7 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q3_7" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <template v-if="form.q3_7 === 'yes'">
          <div class="question-block">
            <div class="q-label"><span class="q-num">3.8</span> ໄພພິບັດທີ່ເກີດຂຶ້ນ <span class="badge badge-info">ເລືອກໄດ້ຫຼາຍ</span></div>
            <div class="options-list">
              <label v-for="opt in disasterTypes" :key="opt.val" class="opt-item" :class="form.q3_8.includes(opt.val) ? 'selected-check' : ''">
                <input type="checkbox" :value="opt.val" v-model="form.q3_8">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>

          <div class="question-block">
            <div class="q-label"><span class="q-num">3.9</span> ໄພພິບັດນີ້ເກີດຂຶ້ນເລື້ອຍປານໃດ?</div>
            <div class="options-list">
              <label v-for="opt in disasterFreq" :key="opt.val" class="opt-item" :class="form.q3_9 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q3_9" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>

          <div class="question-block">
            <div class="q-label"><span class="q-num">3.10</span> ມີຈັກຄອບຄົວໃນບ້ານທີ່ໄດ້ຮັບຜົນກະທົບ?</div>
            <div class="options-list">
              <label v-for="opt in pctRanges" :key="'310_'+opt.val" class="opt-item" :class="form.q3_10 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q3_10" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>

          <div class="question-block">
            <div class="q-label"><span class="q-num">3.11</span> ປະຊາຊົນທີ່ໄດ້ຮັບການຟື້ນຟູ ຫຼ ໄດ້ຮັບການຊ່ວຍເຫຼືອ</div>
            <div class="options-list">
              <label v-for="opt in [...pctRanges, {val:'none',label:'ບໍ່ມີ'}, {val:'dk',label:'ບໍ່ຮູ້'}]" :key="'311_'+opt.val" class="opt-item" :class="form.q3_11 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q3_11" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>

          <div class="question-block">
            <div class="q-label"><span class="q-num">3.12</span> ວິທີໄດ້ຮັບການຟື້ນຟູ <span class="badge badge-info">ເລືອກໄດ້ຫຼາຍ</span></div>
            <div class="options-list">
              <label v-for="opt in recoveryMethods" :key="opt.val" class="opt-item" :class="form.q3_12.includes(opt.val) ? 'selected-check' : ''">
                <input type="checkbox" :value="opt.val" v-model="form.q3_12">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>
        </template>

        <div class="question-block">
          <div class="q-label"><span class="q-num">3.13</span> ຊຸມຊົນນີ້ໄດ້ປະສົບກັບບັນຫາຂາດແຄນເຂົ້າ ໃນປີທີ່ຜ່ານມາບໍ່?</div>
          <div class="options-list inline-2">
            <label v-for="opt in foodSecOpts" :key="opt.val" class="opt-item" :class="form.q3_13 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q3_13" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <template v-if="form.q3_13 === 'shortage'">
          <div class="question-block">
            <div class="q-label"><span class="q-num">3.14</span> ອັດຕາສ່ວນຮ້ອຍຂອງຄົວເຮືອນທີ່ປະສົບກັບບັນຫາຂາດແຄນເຂົ້າ</div>
            <div class="options-list">
              <label v-for="opt in pctRanges" :key="'314_'+opt.val" class="opt-item" :class="form.q3_14 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q3_14" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>

          <div class="question-block">
            <div class="q-label"><span class="q-num">3.15</span> ຊຸມຊົນປະສົບກັບບັນຫາຂາດແຄນເຂົ້າໃນເດືອນໃດ? <span class="badge badge-info">ເລືອກໄດ້ຫຼາຍ</span></div>
            <div class="month-grid">
              <label v-for="m in months" :key="m.val" class="month-item" :class="form.q3_15.includes(m.val) ? 'selected' : ''">
                <input type="checkbox" :value="m.val" v-model="form.q3_15">
                {{ m.label }}
              </label>
              <label class="month-item" :class="form.q3_15.includes('dk') ? 'selected' : ''">
                <input type="checkbox" value="dk" v-model="form.q3_15">
                ບໍ່ຮູ້
              </label>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- ===== SECTION IV: ພື້ນຖານໂຄງລ່າງ ===== -->
    <div v-if="currentSection === 3" class="section-card">
      <div class="section-header" :style="{background: 'linear-gradient(135deg, #512e5f, #4a235a)'}">
        <span class="section-icon">🏫</span>
        <div class="section-title-wrap">
          <h2>IV. ພື້ນຖານໂຄງລ່າງ ຂອງອາຫານທ່ຽງໃນໂຮງຮຽນ</h2>
          <p>School Meal Infrastructure</p>
        </div>
      </div>
      <div class="section-body">

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.1</span> ໂຮງຮຽນນີ້ມີພື້ນຖານໂຄງລ່າງຫຍັງແດ່? <span class="badge badge-info">ໝາຍທັງໝົດ ຖ້າມີ</span></div>
          <div class="options-list">
            <label v-for="opt in infraItems" :key="opt.val" class="opt-item" :class="form.q4_1.includes(opt.val) ? 'selected-check' : ''">
              <input type="checkbox" :value="opt.val" v-model="form.q4_1">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.2</span> ໂຮງຮຽນໄດ້ມີການເຮັດສວນຄົວຂອງໂຮງຮຽນບໍ່?</div>
          <div class="options-list inline-2">
            <label class="opt-item" :class="form.q4_2 === 'yes' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_2" value="yes"><span class="opt-text">✅ ມີ</span>
            </label>
            <label class="opt-item" :class="form.q4_2 === 'no' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_2" value="no"><span class="opt-text">❌ ບໍ່ມີ</span>
            </label>
          </div>
        </div>

        <template v-if="form.q4_2 === 'yes'">
          <div class="question-block">
            <div class="q-label"><span class="q-num">4.2.1</span> ໂຮງຮຽນໄດ້ເກັບກ່ຽວພືດຜັກ ຫຼ ອາຫານໃດໆ ຈາກສວນ ໃນປີນີ້?</div>
            <div class="options-list">
              <label v-for="opt in harvestPct" :key="opt.val" class="opt-item" :class="form.q4_2_1 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q4_2_1" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>

          <div class="question-block">
            <div class="q-label"><span class="q-num">4.2.3</span> ສວນຄົວໂຮງຮຽນໄດ້ຮັບການເບິ່ງແຍງ ຕະຫຼອດປີ ລວມທັງຊ່ວງປິດພາກຮຽນ?</div>
            <div class="options-list inline-2">
              <label class="opt-item" :class="form.q4_2_3 === 'yes' ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q4_2_3" value="yes"><span class="opt-text">✅ ແມ່ນ</span>
              </label>
              <label class="opt-item" :class="form.q4_2_3 === 'no' ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q4_2_3" value="no"><span class="opt-text">❌ ບໍ່ແມ່ນ</span>
              </label>
            </div>
          </div>

          <div class="question-block" v-if="form.q4_2_3 === 'yes'">
            <div class="q-label"><span class="q-num">4.2.4</span> ແມ່ນໃຜທີ່ດູແລສວນຄົວໂຮງຮຽນໃນຊ່ວງໂຮງຮຽນພັກ?</div>
            <div class="options-list">
              <label v-for="opt in gardenCare" :key="opt.val" class="opt-item" :class="form.q4_2_4 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q4_2_4" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>
        </template>

        <div class="question-block" v-if="form.q4_2 === 'no'">
          <div class="q-label"><span class="q-num">4.2.2</span> ເຫດຜົນຫຼັກທີ່ໂຮງຮຽນບໍ່ມີສວນຄົວ</div>
          <div class="options-list">
            <label v-for="opt in noGardenReasons" :key="opt.val" class="opt-item" :class="form.q4_2_2 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_2_2" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
            <label class="opt-item" :class="form.q4_2_2 === 'other' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_2_2" value="other">
              <span class="opt-text">ເຫດຜົນອື່ນໆ
                <span class="opt-sub" v-if="form.q4_2_2 === 'other'">
                  <input class="form-input" v-model="form.q4_2_2_other" placeholder="ລະບຸ...">
                </span>
              </span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.3</span> ໂຮງຮຽນມີການລ້ຽງສັດນ້ອຍ (ເປັດ, ໄກ່, ປາ, ກົບ, ...)ສຳລັບອາຫານທ່ຽງ?</div>
          <div class="options-list inline-2">
            <label class="opt-item" :class="form.q4_3 === 'yes' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_3" value="yes"><span class="opt-text">✅ ມີ</span>
            </label>
            <label class="opt-item" :class="form.q4_3 === 'no' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_3" value="no"><span class="opt-text">❌ ບໍ່ມີ</span>
            </label>
          </div>
        </div>

        <div class="question-block" v-if="form.q4_3 === 'yes'">
          <div class="q-label"><span class="q-num">4.3.1</span> ໂຮງຮຽນໄດ້ນຳເອົາສັດລ້ຽງ ເພື່ອປະກອບສ່ວນໃນການປຸງແຕ່ງອາຫານ ໃນປີນີ້?</div>
          <div class="options-list">
            <label v-for="opt in harvestPct" :key="'431_'+opt.val" class="opt-item" :class="form.q4_3_1 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_3_1" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.4</span> ໂຮງຮຽນມີນ້ຳໃຊ້ເປັນປົກກະຕິບໍ່?</div>
          <div class="options-list">
            <label v-for="opt in waterAvail" :key="opt.val" class="opt-item" :class="form.q4_4 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_4" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.5</span> ໂຮງຮຽນມີການເຂົ້າເຖິງແຫຼ່ງນ້ຳທີ່ໃຊ້ງານໄດ້ປະເພດໃດ?</div>
          <div class="options-list">
            <label v-for="opt in waterSources" :key="opt.val" class="opt-item" :class="form.q4_5 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_5" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.6</span> ໂຮງຮຽນໄດ້ຈັດຊື້ອາຫານເພີ່ມ ສຳລັບອາຫານທ່ຽງ?</div>
          <div class="options-list inline-2">
            <label class="opt-item" :class="form.q4_6 === 'yes' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_6" value="yes"><span class="opt-text">✅ ແມ່ນ</span>
            </label>
            <label class="opt-item" :class="form.q4_6 === 'no' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_6" value="no"><span class="opt-text">❌ ບໍ່ແມ່ນ</span>
            </label>
          </div>
        </div>

        <div class="question-block" v-if="form.q4_6 === 'yes'">
          <div class="q-label"><span class="q-num">4.7</span> ໂຮງຮຽນໄດ້ຈັດຊື້ອາຫານເພີ່ມ ແນວໃດ? <span class="badge badge-info">ເລືອກໄດ້ຫຼາຍ</span></div>
          <div class="options-list">
            <label v-for="opt in foodSources" :key="opt.val" class="opt-item" :class="form.q4_7.includes(opt.val) ? 'selected-check' : ''">
              <input type="checkbox" :value="opt.val" v-model="form.q4_7">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.8</span> ມີຜູ້ຜະລິດກະສິກຳທ້ອງຖິ່ນ ຫຼ ຕະຫຼາດ ທີ່ໂຮງຮຽນສາມາດຊື້ໄດ້?</div>
          <div class="options-list inline-2">
            <label class="opt-item" :class="form.q4_8 === 'yes' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_8" value="yes"><span class="opt-text">✅ ມີ</span>
            </label>
            <label class="opt-item" :class="form.q4_8 === 'no' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_8" value="no"><span class="opt-text">❌ ບໍ່ມີ</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.9</span> ມີອາຫານຫຍັງແດ່ທີ່ສາມາດຊື້ໄດ້?</div>
          <textarea class="form-textarea" v-model="form.q4_9" placeholder="ລະບຸອາຫານທີ່ສາມາດຊື້ໄດ້..."></textarea>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.10</span> ໂຮງຮຽນມີບັນຊີທະນາຄານທີ່ຍັງຖືກນຳໃຊ້ຢູ່ບໍ່?</div>
          <div class="options-list inline-2">
            <label v-for="opt in yesNoUnknown" :key="'410_'+opt.val" class="opt-item" :class="form.q4_10 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_10" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">4.11</span> ຄພສບ ໄດ້ແຈ້ງໃຫ້ຮັບຮູ້ກ່ອນທີ່ຈະຖອນເງິນອອກຈາກບັນຊີ?</div>
          <div class="options-list inline-2">
            <label v-for="opt in notifyOpts" :key="opt.val" class="opt-item" :class="form.q4_11 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q4_11" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== SECTION V: ການປະກອບສ່ວນ ===== -->
    <div v-if="currentSection === 4" class="section-card">
      <div class="section-header" :style="{background: 'linear-gradient(135deg, #1a5276, #21618c)'}">
        <span class="section-icon">🤝</span>
        <div class="section-title-wrap">
          <h2>V. ການປະກອບສ່ວນຈາກຊຸມຊົນ</h2>
          <p>Community Contributions</p>
        </div>
      </div>
      <div class="section-body">

        <div class="question-block">
          <div class="q-label"><span class="q-num">5.1</span> ໂຮງຮຽນ ແລະ ຄພສບ ໄດ້ຮັບການປະກອບສ່ວນຈາກຊຸມຊົນ ປະເພດໃດ? <span class="badge badge-info">ເລືອກໄດ້ຫຼາຍ</span></div>
          <div class="options-list">
            <label v-for="opt in contributionTypes" :key="opt.val" class="opt-item" :class="form.q5_1.includes(opt.val) ? 'selected-check' : ''">
              <input type="checkbox" :value="opt.val" v-model="form.q5_1">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <template v-if="form.q5_1.includes('cash')">
          <div class="question-block">
            <div class="q-label"><span class="q-num">5.2</span> ເປີເຊັນຂອງຄົວເຮືອນທີ່ປະກອບສ່ວນເປັນເງິນສົດ <em>(ຕາມການກຳນົດ/ພັນທະ)</em> ໃນສົກຮຽນຜ່ານມາ</div>
            <div class="options-list">
              <label v-for="opt in pctRangesRev" :key="'52_'+opt.val" class="opt-item" :class="form.q5_2 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q5_2" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>

          <div class="question-block">
            <div class="q-label"><span class="q-num">5.3</span> ເປີເຊັນຂອງຄົວເຮືອນທີ່ປະກອບສ່ວນເງິນສົດ <em>(ດ້ວຍຄວາມສະໝັກໃຈ)</em></div>
            <div class="options-list">
              <label v-for="opt in pctRangesRev" :key="'53_'+opt.val" class="opt-item" :class="form.q5_3 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q5_3" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>

          <div class="question-block">
            <div class="q-label"><span class="q-num">5.4</span> ການປະກອບສ່ວນເງິນສົດ (ຕາມພັນທະ) ມີເລື້ອຍປານໃດ?</div>
            <div class="options-list">
              <label v-for="opt in contribFreq" :key="opt.val" class="opt-item" :class="form.q5_4 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q5_4" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>

          <div class="question-block">
            <div class="q-label"><span class="q-num">5.5</span> ການປະກອບສ່ວນເງິນສົດ (ຕາມພັນທະ) ຈຳນວນເທົ່າໃດຕໍ່ຄອບຄົວ?</div>
            <div class="options-list">
              <label v-for="opt in cashAmounts" :key="opt.val" class="opt-item" :class="form.q5_5 === opt.val ? 'selected-radio' : ''">
                <input type="radio" v-model="form.q5_5" :value="opt.val">
                <span class="opt-text">{{ opt.label }}</span>
              </label>
            </div>
          </div>
        </template>

        <div class="question-block" v-if="form.q5_1.includes('food')">
          <div class="q-label"><span class="q-num">5.6</span> ເປີເຊັນຂອງຄົວເຮືອນທີ່ປະກອບສ່ວນອາຫານ (ສົດ ຫຼ ແຫ້ງ)</div>
          <div class="options-list">
            <label v-for="opt in pctRangesRev" :key="'56_'+opt.val" class="opt-item" :class="form.q5_6 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q5_6" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block" v-if="form.q5_1.includes('labor')">
          <div class="q-label"><span class="q-num">5.7</span> ອັດຕາສ່ວນຮ້ອຍຂອງຄົວເຮືອນທີ່ສະໜອງ ແຮງງານ</div>
          <div class="options-list">
            <label v-for="opt in pctRangesRev" :key="'57_'+opt.val" class="opt-item" :class="form.q5_7 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q5_7" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block" v-if="form.q5_1.includes('material')">
          <div class="q-label"><span class="q-num">5.8</span> ອັດຕາສ່ວນຮ້ອຍຂອງຄົວເຮືອນທີ່ສະໜອງ ວັດສະດຸກໍ່ສ້າງ</div>
          <div class="options-list">
            <label v-for="opt in pctRangesRev" :key="'58_'+opt.val" class="opt-item" :class="form.q5_8 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q5_8" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">5.9</span> ສາເຫດຫຼັກທີ່ເຮັດໃຫ້ໂຮງຮຽນບໍ່ໄດ້ຮັບການປະກອບສ່ວນຈາກຊຸມຊົນຢ່າງພຽງພໍ</div>
          <div class="options-list">
            <label v-for="opt in lowContribReasons" :key="opt.val" class="opt-item" :class="form.q5_9 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q5_9" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">5.10</span> ໃນອາທິດທີ່ຜ່ານມາ, ໄດ້ແຕ່ງກິນໃນໂຮງຮຽນຈັກມື້?</div>
          <div class="options-list">
            <label v-for="opt in cookingFreq" :key="opt.val" class="opt-item" :class="form.q5_10 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q5_10" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">5.11</span> ໃນສົກຮຽນນີ້, ໂດຍສະເລ່ຍ ພາຍໃນໜຶ່ງອາທິດ ໂຮງຮຽນໄດ້ແຕ່ງກິນຈັກມື້?</div>
          <div class="options-list">
            <label v-for="opt in cookingFreq" :key="'511_'+opt.val" class="opt-item" :class="form.q5_11 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q5_11" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">5.12</span> ເຫດຜົນຫຼັກທີ່ບໍ່ມີການແຕ່ງອາຫານທ່ຽງໃນໂຮງຮຽນ</div>
          <div class="options-list">
            <label v-for="opt in noCookReasons" :key="opt.val" class="opt-item" :class="form.q5_12 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q5_12" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== SECTION VI: ໜ້າທີ່ ຄພສບ ===== -->
    <div v-if="currentSection === 5" class="section-card">
      <div class="section-header" :style="{background: 'linear-gradient(135deg, #145a32, #0b5345)'}">
        <span class="section-icon">📊</span>
        <div class="section-title-wrap">
          <h2>VI. ໜ້າທີ່ ຄພສບ ຕໍ່ກັບໂຄງການອາຫານທ່ຽງ</h2>
          <p>VEDC Roles & Responsibilities</p>
        </div>
      </div>
      <div class="section-body">

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.1</span> ສະມາຊິກ ຄພສບ ໄດ້ມີປະຊຸມ ຢ່າງໜ້ອຍຈັກຄັ້ງຕໍ່ໜຶ່ງປີ?</div>
          <div class="options-list">
            <label v-for="opt in meetingFreq" :key="opt.val" class="opt-item" :class="form.q6_1 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_1" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.2</span> ຄພສບ ມີການບັນທຶກບັນຊີ ສຳລັບບໍລິຫານເງິນທຶນ (ກອງທຶນ) ບໍ?</div>
          <div class="options-list inline-2">
            <label v-for="opt in yesNoUnknown" :key="'62_'+opt.val" class="opt-item" :class="form.q6_2 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_2" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
          <div v-if="form.q6_2 === 'yes'" class="q-note warn" style="margin-top:8px">
            📋 ຜູ້ສອບຖາມຄວນກວດກາ ປຶ້ມບັນຊີ ສຳລັບຢືນຢັນ
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.3</span> ໃນປັດຈຸບັນ ຫຼ ໃນອະດີດ (2 ປີຜ່ານມາ), ຄພສບ ມີບົດລາຍງານການໃຊ້ຈ່າຍ ກ່ຽວກັບທຶນຊ່ວຍເຫຼືອ/ເງິນອຸດໜູນ ເຖິງຫ້ອງການສຶກສາ ແລະ ກີລາເມືອງ?</div>
          <div class="options-list inline-2">
            <label v-for="opt in yesNoUnknown" :key="'63_'+opt.val" class="opt-item" :class="form.q6_3 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_3" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.4</span> ຄພສບ ໄດ້ມີການຈັດກອງປະຊຸມຂັ້ນບ້ານ ເພື່ອແລກປ່ຽນ ຄວາມຄືບໜ້າ, ຜົນໄດ້ຮັບ ຫຼ ຊອກຫາຄຳຄິດເຫັນ ຈາກຊຸມຊົນ ເລື້ອຍໆປານໃດ?</div>
          <div class="options-list">
            <label v-for="opt in meetingFreq" :key="'64_'+opt.val" class="opt-item" :class="form.q6_4 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_4" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.5</span> ທ່ານສາມາດຍົກຕົວຢ່າງຂອງບັນຫາທີ່ເກີດຂຶ້ນຢູ່ໂຮງຮຽນໄດ້ບໍ?</div>
          <div class="options-list inline-2">
            <label class="opt-item" :class="form.q6_5 === 'yes' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_5" value="yes"><span class="opt-text">A. ສາມາດຍົກຕົວຢ່າງໄດ້</span>
            </label>
            <label class="opt-item" :class="form.q6_5 === 'no' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_5" value="no"><span class="opt-text">B. ບໍ່ສາມາດຍົກຕົວຢ່າງໄດ້</span>
            </label>
          </div>
        </div>

        <div class="question-block" v-if="form.q6_5 === 'yes'">
          <div class="q-label"><span class="q-num">6.6</span> ຄພສບ ໄດ້ພົບບັນຫາກ່ຽວກັບຫຍັງ?</div>
          <div class="options-list">
            <label v-for="opt in problemStatus" :key="opt.val" class="opt-item" :class="form.q6_6 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_6" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
          <div style="margin-top:12px">
            <div style="font-size:13px;font-weight:600;color:var(--text-muted);margin-bottom:6px">ບັນຫາທີ່ພົບ (ອະທິບາຍ):</div>
            <textarea class="form-textarea" v-model="form.q6_6_desc" placeholder="ອະທິບາຍບັນຫາທີ່ພົບ..."></textarea>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.7</span> ຄພສບ ຈະແກ້ໄຂບັນຫາທີ່ເກີດຂຶ້ນ ກ່ຽວກັບໂຄງການອາຫານທ່ຽງ ແນວໃດ?</div>
          <div class="options-list">
            <label v-for="opt in problemSolveMethods" :key="opt.val" class="opt-item" :class="form.q6_7 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_7" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.8</span> ແມ່ນໃຜໃນສະມາຊິກ ຄພສບ ທີ່ສາມາດແກ້ໄຂບັນຫາໄດ້?</div>
          <div class="options-list">
            <label v-for="opt in whoSolves" :key="opt.val" class="opt-item" :class="form.q6_8 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_8" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.9</span> ຊ່ວງ 6 ເດືອນຜ່ານມາ, ຄພສບ ໄດ້ມີການສ້ອມແປງ ຫຼ ຍົກລະດັບ ພື້ນຖານໂຄງລ່າງ?</div>
          <div class="options-list">
            <label v-for="opt in repairStatus" :key="opt.val" class="opt-item" :class="form.q6_9 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_9" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.10</span> ຄພສບ ມີແຜນພັດທະນາໂຮງຮຽນປະຈຳປີ?</div>
          <div class="options-list inline-2">
            <label class="opt-item" :class="form.q6_10 === 'no' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_10" value="no"><span class="opt-text">❌ ບໍ່ມີແຜນ</span>
            </label>
            <label class="opt-item" :class="form.q6_10 === 'yes' ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_10" value="yes"><span class="opt-text">✅ ແມ່ນ, ມີແຜນ</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.11</span> ໃນປັດຈຸບັນ ຫຼ ໃນອະດີດ (2 ປີ), ຄພສບ ມີບົດລາຍງານກິດຈະກຳອາຫານທ່ຽງ ເຖິງຫ້ອງການສຶກສາ ແລະ ກີລາເມືອງ?</div>
          <div class="options-list inline-2">
            <label v-for="opt in yesNoUnknown" :key="'611_'+opt.val" class="opt-item" :class="form.q6_11 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_11" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block" v-if="form.q6_11 === 'yes'">
          <div class="q-label"><span class="q-num">6.12</span> ຄພສບ ມີບົດລາຍງານ ປະເພດໃດ?</div>
          <div class="options-list">
            <label v-for="opt in reportTypes" :key="opt.val" class="opt-item" :class="form.q6_12 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_12" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div class="question-block">
          <div class="q-label"><span class="q-num">6.13</span> ຄພສບ ມີການກຳນົດຕາຕະລາງການປຸງແຕ່ງອາຫານທ່ຽງໃນໂຮງຮຽນບໍ?</div>
          <div class="options-list inline-2">
            <label v-for="opt in yesNoUnknown" :key="'613_'+opt.val" class="opt-item" :class="form.q6_13 === opt.val ? 'selected-radio' : ''">
              <input type="radio" v-model="form.q6_13" :value="opt.val">
              <span class="opt-text">{{ opt.label }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== SECTION VII: ຂໍ້ມູນຮູບພາບ ===== -->
    <div v-if="currentSection === 6" class="section-card">
      <div class="section-header" :style="{background: 'linear-gradient(135deg, #6e2f1a, #784212)'}">
        <span class="section-icon">📷</span>
        <div class="section-title-wrap">
          <h2>VII. ຂໍ້ມູນຮູບພາບ</h2>
          <p>Photo Documentation</p>
        </div>
      </div>
      <div class="section-body">
        <p style="font-size:13px;color:var(--text-muted);margin-bottom:14px">ກະລຸນາຖ່າຍຮູບຕາມລາຍການຂ້າງລຸ່ມນີ້ ແລະ ບັນທຶກໄວ້ໃນລະບົບ</p>
        <div class="photo-grid">
          <div v-for="item in photoItems" :key="item.val" class="photo-slot">
            <div class="photo-icon">📸</div>
            <div class="photo-label">{{ item.label }}</div>
            <input type="file" accept="image/*" @change="handlePhoto($event, item.val, 1)" style="display:none" :id="'ph_'+item.val+'_1'">
            <img v-if="photos[item.val+'_1']" :src="photos[item.val+'_1']" class="photo-preview-img">
            <div style="margin-top:8px; display:flex; gap:5px;">
              <button class="btn btn-secondary btn-sm" @click="triggerFile(item.val, 1)">📂 {{ photos[item.val+'_1'] ? 'ປ່ຽນຮູບ' : 'ເລືອກຮູບ' }}</button>
              <button v-if="photos[item.val+'_1']" class="btn btn-secondary btn-sm" @click="$delete(photos, item.val+'_1')" style="color:var(--danger)">🗑️</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== SECTION VIII: ຄຳເຫັນ ===== -->
    <div v-if="currentSection === 7" class="section-card">
      <div class="section-header" :style="{background: 'linear-gradient(135deg, #1b2631, #212f3d)'}">
        <span class="section-icon">💬</span>
        <div class="section-title-wrap">
          <h2>VIII. ຄຳເຫັນ / ຄຳແນະນຳ / ການສັງເກດການ</h2>
          <p>Comments & Observations</p>
        </div>
      </div>
      <div class="section-body">
        <div class="question-block">
          <div class="q-label"><span class="q-num">8.1</span> ຄຳເຫັນ/ຄຳແນະນຳ/ການສັງເກດ ຈາກຜູ້ໃຫ້ສຳພາດ</div>
          <textarea class="form-textarea" v-model="form.q8_1" placeholder="ຄຳເຫັນ ຫຼ ຂໍ້ສັງເກດໃດໆ ຈາກຜູ້ຕອບ..." style="min-height:100px"></textarea>
        </div>
        <div class="question-block">
          <div class="q-label"><span class="q-num">8.2</span> ຄຳເຫັນ/ຄຳແນະນຳ/ການສັງເກດ ຈາກນັກເກັບຂໍ້ມູນ</div>
          <textarea class="form-textarea" v-model="form.q8_2" placeholder="ການສັງເກດ ຫຼ ໝາຍເຫດ ຈາກຜູ້ເກັບຂໍ້ມູນ..." style="min-height:100px"></textarea>
        </div>

        <!-- SUMMARY -->
        <div class="divider"></div>
        <h3 style="font-size:15px;color:var(--primary);margin-bottom:12px;">📋 ສະຫຼຸບຂໍ້ມູນ</h3>
        <table class="summary-table">
          <thead><tr><th>ໝວດ</th><th>ຂໍ້ມູນ</th></tr></thead>
          <tbody>
            <tr><td>ໂຮງຮຽນ</td><td>{{ meta.schoolName || '-' }} ({{ meta.schoolCode || '-' }})</td></tr>
            <tr><td>ບ້ານ</td><td>{{ meta.village || '-' }} — {{ meta.district || '-' }}</td></tr>
            <tr><td>ວັນທີ</td><td>{{ meta.date || '-' }}</td></tr>
            <tr><td>ຜູ້ສຳພາດ</td><td>{{ meta.interviewer || '-' }}</td></tr>
            <tr><td>ຈຳນວນຜູ້ຮ່ວມ</td><td>{{ form.q2_1 || '-' }} ຄົນ</td></tr>
            <tr><td>ຈຳນວນຄົວເຮືອນ</td><td>{{ form.q2_2 || '-' }}</td></tr>
            <tr><td>ການເຂົ້າເຖິງ</td><td>{{ accessLevels.find(a => a.val === form.q3_1) ? accessLevels.find(a => a.val === form.q3_1).label : '-' }}</td></tr>
            <tr><td>ໄພພິບັດ</td><td>{{ form.q3_7 === 'yes' ? 'ມີ' : form.q3_7 === 'no' ? 'ບໍ່ມີ' : '-' }}</td></tr>
            <tr><td>ສວນຄົວ</td><td>{{ form.q4_2 === 'yes' ? 'ມີ' : form.q4_2 === 'no' ? 'ບໍ່ມີ' : '-' }}</td></tr>
            <tr><td>ລ້ຽງສັດ</td><td>{{ form.q4_3 === 'yes' ? 'ມີ' : form.q4_3 === 'no' ? 'ບໍ່ມີ' : '-' }}</td></tr>
            <tr><td>ການປະກອບສ່ວນ</td><td>{{ form.q5_1.length ? form.q5_1.join(', ') : '-' }}</td></tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- NAV BUTTONS -->
    <div class="btn-row">
      <button v-if="currentSection > 0" class="btn btn-secondary" @click="prevSection">← ກັບຄືນ</button>
      <button v-if="currentSection < sections.length - 1" class="btn btn-primary" @click="nextSection">ຕໍ່ໄປ →</button>
      <button v-if="currentSection === sections.length - 1" class="btn btn-success" @click="submitForm">✅ ສົ່ງຂໍ້ມູນ</button>
      <button class="btn btn-secondary" @click="saveDraft" style="margin-left:auto">💾 ບັນທຶກ Draft</button>
    </div>
  </div>

  <!-- TOAST -->
  <div class="toast-wrap">
    <div v-for="t in toasts" :key="t.id" class="toast" :class="t.type === 'error' ? 'error' : ''">
      <span class="toast-icon">{{ t.type === 'error' ? '❌' : '✅' }}</span>
      <span class="toast-msg">{{ t.msg }}</span>
    </div>
  </div>

  <!-- SCHOOL SELECTION MODAL -->
  <b-modal ref="school-modal" title="ຄົ້ນຫາ ແລະ ເລືອກໂຮງຮຽນ" hide-footer size="lg" centered header-class="bg-primary text-white" title-class="font-weight-bold">
    <div class="p-2">
     
      
      
     <b-form-input type="text" v-model="schoolSearch" placeholder="ຄົ້ນຫາດ້ວຍ ລະຫັດ ຫຼື ຊື່ໂຮງຮຽນ..." class="mb-3 shadow-sm"></b-form-input>
    
      <div class="table-responsive" style="max-height: 400px;">
        <table class="table table-hover table-bordered custom-modal-table">
          <thead class="thead-light">
            <tr>
              <th style="width: 150px">ລະຫັດ</th>
              <th>ຊື່ໂຮງຮຽນ</th>
              <th class="text-center" style="width: 100px">ເລືອກ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="s in filteredSchools" :key="s.value">
              <td><span class="badge badge-info">{{ s.value }}</span></td>
              <td class="font-weight-bold">{{ s.text }}</td>
              <td class="text-center">
                <b-button size="sm" variant="success" @click="selectSchool(s)">ເລືອກ</b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </b-modal>
</div>

    
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
export default {
    data() {
        return {
            schoolSearch: '',
            schools: [],
            currentSection: 0,
            showHeader: true,
            lastScrollTop: 0,
            submitted: false,
            toasts: [],
            photos: {},
            meta: { interviewer: '', schoolCode: '', schoolName: '', date: '', district: '', village: '', villageCode: '' },
            form: {
                q1_1: '',
                q1_2: '',
                q2_1: '',
                q2_2: '',
                q2_3: '',
                q2_4: '',
                q2_5: '',
                q2_6: '',
                q2_7: [],
                q2_7_other: '',
                q3_1: '',
                q3_2: '',
                q3_3: '',
                q3_4: '',
                q3_5: '',
                q3_6: [],
                q3_7: '',
                q3_8: [],
                q3_9: '',
                q3_10: '',
                q3_11: '',
                q3_12: [],
                q3_13: '',
                q3_14: '',
                q3_15: [],
                q4_1: [],
                q4_2: '',
                q4_2_1: '',
                q4_2_2: '',
                q4_2_2_other: '',
                q4_2_3: '',
                q4_2_4: '',
                q4_3: '',
                q4_3_1: '',
                q4_4: '',
                q4_5: '',
                q4_6: '',
                q4_7: [],
                q4_8: '',
                q4_9: '',
                q4_10: '',
                q4_11: '',
                q5_1: [],
                q5_2: '',
                q5_3: '',
                q5_4: '',
                q5_5: '',
                q5_6: '',
                q5_7: '',
                q5_8: '',
                q5_9: '',
                q5_10: '',
                q5_11: '',
                q5_12: '',
                q6_1: '',
                q6_2: '',
                q6_3: '',
                q6_4: '',
                q6_5: '',
                q6_6: '',
                q6_6_desc: '',
                q6_7: '',
                q6_8: '',
                q6_9: '',
                q6_10: '',
                q6_11: '',
                q6_12: '',
                q6_13: '',
                q8_1: '',
                q8_2: ''
            },
            sections: [
                { short: 'I. ການອະນຸຍາດ' },
                { short: 'II. ປະຊາກອນ' },
                { short: 'III. ຄວາມສ່ຽງ' },
                { short: 'IV. ໂຄງລ່າງ' },
                { short: 'V. ການປະກອບສ່ວນ' },
                { short: 'VI. ຄພສບ' },
                { short: 'VII. ຮູບພາບ' },
                { short: 'VIII. ຄຳເຫັນ' },
            ],
            sectionDone: [false, false, false, false, false, false, false, false],
            langGroups: [
                { val: 'lao_tai', label: 'ກຸ່ມພາສາລາວໄຕ', sub: 'ລາວ, ໄຕ, ຜູ້ໄທ, ລຶ, ຫງວນ...' },
                { val: 'mon_khmer', label: 'ກຸ່ມພາສາມອນ-ຂະແມ', sub: 'ຄຳມຸ, ໄປຣ, ສິງມຸນ, ອາດຸ...' },
                { val: 'sino_tibetan', label: 'ກຸ່ມພາສາຈີນ-ຕິເບດ', sub: 'ອາຂ່າ, ສິງສິຣິ/ພູນ້ອຍ, ລາຣຸ...' },
                { val: 'hmong_mien', label: 'ກຸ່ມພາສາມົ້ງ-ມຽນ', sub: 'ມົ້ງ, ເອລແມນ' },
            ],
            leaders: [
                { val: 'principal', label: 'ອຳນວຍການ' },
                { val: 'teacher', label: 'ຄູສອນ' },
                { val: 'village_head', label: 'ນາຍບ້ານ' },
                { val: 'womens_union', label: 'ສະຫະພັນແມ່ຍິງບ້ານ' },
                { val: 'parents', label: 'ພໍ່ແມ່ນັກຮຽນ' },
                { val: 'vedc', label: 'ສະມາຊິກຄະນະພັດທະນາສຶກສາຂັ້ນບ້ານ' },
            ],
            accessLevels: [
                { val: 'A', label: 'ຕົວເມືອງ' },
                { val: 'B', label: 'ຢູ່ຊົນນະບົດ — ມີເສັ້ນທາງເຂົ້າເຖິງບ້ານ' },
                { val: 'C', label: 'ຢູ່ຊົນນະບົດ — ບໍ່ມີເສັ້ນທາງເຂົ້າເຖິງບ້ານ' },
            ],
            accessYear: [
                { val: 'all_year', label: 'ເຂົ້າໄດ້ຕະຫຼອດປີ' },
                { val: 'rainy_issues', label: 'ສາມາດເຂົ້າເຖິງໄດ້ຕະຫຼອດທັງປີ ແຕ່ມີບັນຫາໃນຊ່ວງລະດູຝົນ' },
                { val: 'dry_only', label: 'ເຂົ້າເຖິງໄດ້ສະເພາະລະດູແລ້ງ' },
            ],
            transportTypes: [
                { val: 'car', label: 'ສາມາດເຂົ້າເຖິງໄດ້ດ້ວຍລົດໃຫຍ່ (ລົດທີ່ມີ 3 ລໍ້ຂຶ້ນໄປ)' },
                { val: 'motorbike', label: 'ສາມາດເຂົ້າເຖິງໄດ້ດ້ວຍລົດຈັກ (ລົດ 2 ລໍ້ ລວມເຖິງການຍ່າງ)' },
                { val: 'other', label: 'ສາມາດເຂົ້າເຖິງດ້ວຍການຂົນສ່ງອື່ນໆ (ເຊັ່ນ: ເຮືອພາຍ, ເຮືອບິນ)' },
                { val: 'none', label: 'ບໍ່ສາມາດເຂົ້າເຖິງໄດ້' },
            ],
            marketDist: [
                { val: '0_1', label: '0–1 Km' },
                { val: '2_5', label: '2–5 Km' },
                { val: '6_10', label: '6–10 Km' },
                { val: '10plus', label: 'ຫຼາຍກວ່າ 10 Km' },
            ],
            incomeTypes: [
                { val: 'farming', label: 'ເຮັດນາ / ເຮັດໄຮ່ (ເຮັດໄຮ່ຕາມພູສູງ)' },
                { val: 'tourism', label: 'ທ່ອງທ່ຽວ' },
                { val: 'industrial', label: 'ພືດອຸດສາຫະກຳ' },
                { val: 'livestock', label: 'ລ້ຽງສັດ' },
                { val: 'fishing', label: 'ການປະມົງ' },
                { val: 'mining', label: 'ຂຸດຄົ້ນບໍ່ແຮ່' },
                { val: 'cash_crops', label: 'ພືດເສດຖະກິດ' },
                { val: 'forest', label: 'ຫາເຄື່ອງປ່າຂອງດົງ' },
                { val: 'trade', label: 'ຄ້າຂາຍ' },
                { val: 'migrant_work', label: 'ແຮງງານເຄື່ອນຍ້າຍ' },
                { val: 'factory', label: 'ກຳມະກອນໃນໂຮງຈັກໂຮງງານ' },
                { val: 'daily_wage', label: 'ແຮງງານລາຍວັນ' },
                { val: 'weaving', label: 'ເຮັດແຜ່ນແພ/ຕ່ໍາຫູກ (ງານສີລິທຸກຊະນິດ)' },
                { val: 'other', label: 'ອື່ນໆ' },
                { val: 'dk', label: 'ບໍ່ຮູ້' },
            ],
            yesNoUnknown: [
                { val: 'yes', label: '✅ ມີ / ແມ່ນ' },
                { val: 'no', label: '❌ ບໍ່ມີ / ບໍ່ແມ່ນ' },
                { val: 'dk', label: '❓ ບໍ່ຮູ້' },
            ],
            disasterTypes: [
                { val: 'flood', label: 'ໄພນ້ຳຖ້ວມ' },
                { val: 'drought', label: 'ໄພແຫ້ງແລ້ງ' },
                { val: 'pest', label: 'ໄພຈາກສັດຕູພືດຄຸກຄາມ' },
                { val: 'price_rise', label: 'ການເພີ່ມຂຶ້ນຂອງລາຄາສິນຄ້າ' },
                { val: 'illness', label: 'ການເຈັບປ່ວຍ' },
                { val: 'other', label: 'ອື່ນໆ' },
            ],
            disasterFreq: [
                { val: 'never', label: 'ບໍ່ເຄີຍເກີດມາກ່ອນເລີຍ' },
                { val: 'rare', label: 'ດົນໆເທື່ອໜຶ່ງ (5 ປີຂຶ້ນໄປ)' },
                { val: 'sometimes', label: 'ເລື້ອຍໆສົມຄວນ (ສອງສາມປີເທື່ອໜຶ່ງ)' },
                { val: 'often', label: 'ເລື້ອຍໆ (ຢ່າງໜ້ອຍໜຶ່ງຄັ້ງຕໍ່ປີ)' },
            ],
            pctRanges: [
                { val: '1_25', label: '1–25% (ຈຳນວນໜ້ອຍ)' },
                { val: '26_50', label: '26–50% (ປະມານເກືອບເຄິ່ງ ຫຼ ເຄິ່ງໜຶ່ງ)' },
                { val: '51_75', label: '51–75% (ຫຼາຍກວ່າເຄິ່ງໜຶ່ງ)' },
                { val: '76_100', label: '76–100% (ໝົດທຸກຄົນ ຫຼ ເກືອບໝົດທຸກຄົນ)' },
                { val: 'dk', label: 'ບໍ່ຮູ້' },
            ],
            pctRangesRev: [
                { val: '76_100', label: '76–100% ຂອງຄົວເຮືອນທັງໝົດ' },
                { val: '51_75', label: '51–75% ຂອງຄົວເຮືອນທັງໝົດ' },
                { val: '26_50', label: '26–50% ຂອງຄົວເຮືອນທັງໝົດ' },
                { val: '0_25', label: '0–25% ຂອງຄົວເຮືອນທັງໝົດ' },
            ],
            recoveryMethods: [
                { val: 'self', label: 'ຟື້ນຟູໄດ້ດ້ວຍຕົນເອງ ໂດຍບໍ່ອາໄສການຊ່ວຍເຫຼືອ' },
                { val: 'loan', label: 'ຢືມເງິນຈາກທະນາຄານ ຫຼ ສິນຄ້າຈາກຄອບຄົວ ແລະ/ຫຼ ໝູ່ເພື່ອນ' },
                { val: 'formal_aid', label: 'ໄດ້ຮັບການຊ່ວຍເຫຼືອ (ເງິນສົດ ຫຼ ສິ່ງຂອງ) ຢ່າງເປັນທາງການ ຫຼ ບໍ່ເປັນທາງການ' },
                { val: 'temp_move', label: 'ຍ້າຍໄປຢູ່ບ້ານອື່ນ (ຊົ່ວຄາວ)' },
                { val: 'perm_move', label: 'ຍ້າຍໄປຢູ່ບ້ານອື່ນ (ຖາວອນ)' },
                { val: 'other', label: 'ອື່ນໆ' },
            ],
            foodSecOpts: [
                { val: 'shortage', label: '⚠️ ຂາດແຄນ (ເຂົ້າບໍ່ກຸ້ມກິນ)' },
                { val: 'sufficient', label: '✅ ບໍ່ຂາດແຄນ (ເຂົ້າກຸ້ມກິນ)' },
                { val: 'dk', label: '❓ ບໍ່ຮູ້' },
            ],
            months: [
                { val: '01', label: 'ມັງກອນ' }, { val: '02', label: 'ກຸມພາ' }, { val: '03', label: 'ມີນາ' },
                { val: '04', label: 'ເມສາ' }, { val: '05', label: 'ພຶດສະພາ' }, { val: '06', label: 'ມິຖຸນາ' },
                { val: '07', label: 'ກໍລະກົດ' }, { val: '08', label: 'ສິງຫາ' }, { val: '09', label: 'ກັນຍາ' },
                { val: '10', label: 'ຕຸລາ' }, { val: '11', label: 'ພະຈິກ' }, { val: '12', label: 'ທັນວາ' },
            ],
            infraItems: [
                { val: 'handwash', label: 'ບ່ອນລ້າງມື / ອ່າງລ້າງມື' },
                { val: 'toilet', label: 'ຫ້ອງນ້ຳ' },
                { val: 'dining', label: 'ບ່ອນກິນເຂົ້າ' },
                { val: 'kitchen', label: 'ເຮືອນຄົວ' },
                { val: 'storage', label: 'ສາງອາຫານ' },
                { val: 'water_source', label: 'ແຫຼ່ງນ້ຳໃຊ້ (ນ້ຳບາດານ, ນ້ຳສ້າງ, ນ້ຳລິນ, ນ້ຳໜ້ວຍ, ...)' },
            ],
            harvestPct: [
                { val: 'never', label: 'ບໍ່ເຄີຍ' },
                { val: '1_25', label: '1–25% (ໜ້ອຍຄັ້ງ)' },
                { val: '26_50', label: '26–50% (ປະມານເກືອບເຄິ່ງ)' },
                { val: '51_75', label: '51–75% (ຫຼາຍກວ່າເຄິ່ງໜຶ່ງ)' },
                { val: '76_100', label: '76–100% (ທຸກໆຄັ້ງ ຫຼ ເກືອບທຸກຄັ້ງ)' },
                { val: 'dk', label: 'ບໍ່ຮູ້' },
            ],
            noGardenReasons: [
                { val: 'no_land', label: 'ບໍ່ມີພື້ນທີ່ປູກຝັງ' },
                { val: 'bad_soil', label: 'ດິນບໍ່ເໝາະສົມໃນການປູກພືດ' },
                { val: 'no_water', label: 'ບໍ່ມີນ້ຳໃຊ້' },
                { val: 'no_leader', label: 'ບໍ່ມີຜູ້ນຳພາ ແລະ ເບິ່ງແຍງສວນຄົວໃນໂຮງຮຽນ' },
                { val: 'no_community', label: 'ຂາດການສະໜັບສະໜູນຈາກຊຸມຊົນໃນການເບິ່ງແຍງສວນຄົວ' },
            ],
            gardenCare: [
                { val: 'school_staff', label: 'ຄູ ຫຼ ພະນັກງານໃນໂຮງຮຽນ' },
                { val: 'parents', label: 'ພໍ່ແມ່ນັກຮຽນ' },
                { val: 'community', label: 'ສະມາຊິກອື່ນໆຂອງຊຸມຊົນ' },
            ],
            waterAvail: [
                { val: 'year_round', label: 'ມີນ້ຳໃຊ້ຕະຫຼອດສົກຮຽນ' },
                { val: 'insufficient', label: 'ມີ ແຕ່ນ້ຳບໍ່ພໍໃຊ້ຕະຫຼອດສົກຮຽນ' },
                { val: 'not_drinkable', label: 'ມີ ແຕ່ໃຊ້ດື່ມບໍ່ໄດ້' },
                { val: 'broken', label: 'ບໍ່ມີ ເພາະແຫຼ່ງນ້ຳເປ່ / ເສຍຫາຍ ແລະ ຍັງບໍ່ທັນສ້ອມແປງ' },
                { val: 'no_source', label: 'ບໍ່ມີ ບໍ່ມີແຫຼ່ງນ້ຳໃຊ້' },
                { val: 'dk', label: 'ບໍ່ຮູ້' },
            ],
            waterSources: [
                { val: 'piped_year', label: 'ນ້ຳສ້າງທີ່ໃຊ້ງານໄດ້ຕະຫຼອດ' },
                { val: 'piped_rain', label: 'ນ້ຳສ້າງທີ່ໃຊ້ງານໄດ້ແຕ່ລະດູຝົນ' },
                { val: 'gravity_year', label: 'ລະບົບນ້ຳລິນທີ່ໃຊ້ງານໄດ້ຕະຫຼອດ' },
                { val: 'gravity_rain', label: 'ລະບົບນ້ຳລິນທີ່ໃຊ້ງານໄດ້ແຕ່ລະດູຝົນ' },
                { val: 'pond_year', label: 'ໜອງນ້ຳທີ່ມີນ້ຳໃຊ້ຕະຫຼອດປີ' },
                { val: 'pond_rain', label: 'ໜອງນ້ຳທີ່ມີນ້ຳໃຊ້ແຕ່ຊ່ວງລະດູຝົນ' },
                { val: 'other_year', label: 'ແຫຼ່ງນ້ຳຊະນິດອື່ນທີ່ມີນ້ຳໃຊ້ຕະຫຼອດປີ' },
                { val: 'other_partial', label: 'ແຫຼ່ງນ້ຳຊະນິດອື່ນທີ່ມີນ້ຳໃຊ້ບາງລະດູການ' },
            ],
            foodSources: [
                { val: 'nearest_market', label: 'ຊື້ຈາກຕະຫຼາດທີ່ໃກ້ທີ່ສຸດ' },
                { val: 'farther_market', label: 'ຊື້ຈາກຕະຫຼາດທີ່ໄກກວ່າ (ຕົວຢ່າງ: ບ່ອນນັ້ນມີລາຄາຕ່ຳກວ່າ)' },
                { val: 'local_farmers', label: 'ຊື້ໂດຍກົງຈາກກະສິກອນທ້ອງຖິ່ນ' },
                { val: 'producer_group', label: 'ຊື້ຈາກກຸ່ມຜູ້ຜະລິດກະສິກຳ' },
                { val: 'local_forage', label: 'ການຫາອາຫານທ້ອງຖິ່ນ ແລະ ອື່ນໆ' },
            ],
            contributionTypes: [
                { val: 'cash', label: '💰 ເງິນສົດ' },
                { val: 'food', label: '🍚 ອາຫານ' },
                { val: 'labor', label: '🔨 ແຮງງານ' },
                { val: 'material', label: '🧱 ວັດສະດຸກໍ່ສ້າງ' },
                { val: 'other', label: '🔄 ປະເພດອື່ນໆ' },
            ],
            contribFreq: [
                { val: 'monthly', label: 'ລາຍເດືອນ' },
                { val: 'per_term', label: 'ລາຍພາກຮຽນ' },
                { val: 'yearly', label: 'ລາຍປີ' },
                { val: 'other', label: 'ອື່ນໆ' },
            ],
            cashAmounts: [
                { val: '0_50k', label: '0–50,000 LAK' },
                { val: '51_100k', label: '51,000–100,000 LAK' },
                { val: '100kplus', label: 'ຫຼາຍກວ່າ 100,000 LAK' },
            ],
            lowContribReasons: [
                { val: 'no_resources', label: 'ບໍ່ມີປັດໄຈພຽງພໍ (ເງິນສົດ, ອາຫານ ຫຼ ແຮງານ)' },
                { val: 'unclear_goals', label: 'ເປົ້າໝາຍ (ຄວາມຄາດຫວັງ) ຂອງຄົວເຮືອນທີ່ບໍ່ຊັດເຈນ' },
                { val: 'no_transparency', label: 'ບໍ່ມີຄວາມໂປ່ງໃສໃນການໃຊ້ຈ່າຍເງິນທີ່ໄດ້ຮັບຈາກການປະກອບສ່ວນ' },
                { val: 'other', label: 'ອື່ນໆ' },
            ],
            cookingFreq: [
                { val: 'all', label: 'ແຕ່ງກິນທຸກມື້' },
                { val: '4_5', label: 'ແຕ່ງກິນ 4 ພາຍໃນ 5 ວັນ' },
                { val: '3_5', label: 'ແຕ່ງກິນ 3 ພາຍໃນ 5 ວັນ' },
                { val: '2_5', label: 'ແຕ່ງກິນ 2 ພາຍໃນ 5 ວັນ' },
                { val: '1_5', label: 'ແຕ່ງກິນ 1 ພາຍໃນ 5 ວັນ' },
                { val: 'none', label: 'ບໍ່ໄດ້ແຕ່ງກິນຈັກວັນ' },
            ],
            noCookReasons: [
                { val: 'no_infra', label: 'ພື້ນຖານໂຄງລ່າງ ແລະ/ຫຼ ອຸປະກອນ ບໍ່ພຽງພໍ' },
                { val: 'no_food', label: 'ອາຫານບໍ່ພຽງພໍ (ເຂົ້າ, ນ້ຳມັນ, ປາກະປ໋ອງ)' },
                { val: 'no_fresh_food', label: 'ການປະກອບສ່ວນດ້ານອາຫານສົດ ແລະ ແຫ້ງ ບໍ່ພຽງພໍ' },
                { val: 'no_cook', label: 'ບໍ່ມີພໍ່ຄົວ' },
                { val: 'school_not_interested', label: 'ໂຮງຮຽນບໍ່ສົນໃຈໃນການແຕ່ງການຫານທ່ຽງ' },
                { val: 'student_not_interested', label: 'ນັກຮຽນບໍ່ສົນໃຈກິນອາຫານທ່ຽງທີ່ປຸງແຕ່ງ ຫຼ ເອົາອາຫານມາເອງ' },
                { val: 'school_closed', label: 'ໂຮງຮຽນປິດ' },
                { val: 'teacher_absent', label: 'ຄູຂາດສອນ' },
            ],
            meetingFreq: [
                { val: 'more_monthly', label: 'ຫຼາຍກວ່າໜຶ່ງຄັ້ງຕໍ່ເດືອນ' },
                { val: 'monthly', label: 'ໜຶ່ງຄັ້ງຕໍ່ເດືອນ' },
                { val: 'per_term', label: 'ໜຶ່ງຄັ້ງຕໍ່ພາກຮຽນ' },
                { val: 'yearly', label: 'ໜຶ່ງຄັ້ງຕໍ່ສົກຮຽນ' },
                { val: 'never', label: 'ບໍ່ເຄີຍປະຊຸມ' },
            ],
            problemStatus: [
                { val: 'solved', label: 'ຄພສບ ສາມາດແກ້ໄຂບັນຫາໄດ້' },
                { val: 'in_progress', label: 'ປັດຈຸບັນ ຄພສບ ກຳລັງພະຍາຍາມແກ້ໄຂບັນຫາ' },
                { val: 'failed', label: 'ຄພສບ ພະຍາຍາມແກ້ໄຂແຕ່ບໍ່ສາມາດແກ້ໄຂໄດ້' },
                { val: 'not_tried', label: 'ຄພສບ ບໍ່ໄດ້ພະຍາຍາມແກ້ໄຂບັນຫາ' },
            ],
            problemSolveMethods: [
                { val: 'internal_meeting', label: 'ຈັດກອງປະຊຸມ ຄພສບ ເພື່ອປຶກສາບັນຫາ ແລະ ຊອກວິທີແກ້ໄຂ' },
                { val: 'community', label: 'ໃຫ້ສະມາຊິກຊຸມຊົນຄົນອື່ນໆ ມີສ່ວນຮ່ວມ ເພື່ອປຶກສາຫາລືກ່ຽວກັບບັນຫາ' },
                { val: 'escalate', label: 'ປຶກສານາຍບ້ານ ຫຼ ອຳນວຍການໂຮງຮຽນ ເພື່ອແກ້ໄຂບັນຫາ' },
            ],
            whoSolves: [
                { val: 'all', label: 'ທັງໝົດໃນສະມາຊິກ ຄພສບ' },
                { val: 'head_not_village', label: 'ຫົວໜ້າຂອງ ຄພສບ (ແຕ່ບໍ່ແມ່ນນາຍບ້ານ)' },
                { val: 'individual', label: 'ບຸກຄົນຢູ່ໃນສະມາຊິກ ຄພສບ' },
                { val: 'village_head', label: 'ນາຍບ້ານ' },
            ],
            repairStatus: [
                { val: 'yes', label: '✅ ແມ່ນ — ໄດ້ສ້ອມແປງ/ຍົກລະດັບ' },
                { val: 'no_needed', label: '❌ ບໍ່ — ບໍ່ມີສິ່ງທີ່ຕ້ອງການສ້ອມແປງ' },
                { val: 'no_pending', label: '⏳ ບໍ່ — ມີໜຶ່ງຢ່າງທີ່ຕ້ອງການສ້ອມແປງ ແຕ່ຍັງບໍ່ສຳເລັດ' },
                { val: 'dk', label: '❓ ບໍ່ຮູ້' },
            ],
            reportTypes: [
                { val: 'progress', label: 'ບົດລາຍງານຄວາມຄືບໜ້າການຈັດຕັ້ງປະຕິບັດ' },
                { val: 'expense', label: 'ບົດລາຍງານການໃຊ້ຈ່າຍ' },
                { val: 'other', label: 'ອື່ນໆ' },
            ],
            notifyOpts: [
                { val: 'yes', label: '✅ ແຈ້ງ' },
                { val: 'no', label: '❌ ບໍ່ແຈ້ງ' },
                { val: 'dk', label: '❓ ບໍ່ຮູ້' },
            ],
            photoItems: [
                { val: 'overview1', label: 'ພາບກ້ວາງຂອງໂຮງຮຽນ' },
                { val: 'building', label: 'ພາບອາຄານໂຮງຮຽນ' },
                { val: 'handwash', label: 'ບ່ອນລ້າງມື / ອ່າງລ້າງມື' },
                { val: 'toilet', label: 'ຫ້ອງນ້ຳ' },
                { val: 'dining', label: 'ບ່ອນກິນເຂົ້າ' },
                { val: 'kitchen', label: 'ເຮືອນຄົວ' },
                { val: 'storage', label: 'ສາງອາຫານ' },
                { val: 'water', label: 'ແຫຼ່ງນ້ຳໃຊ້' },
                { val: 'garden', label: 'ສວນຄົວໂຮງຮຽນ' },
                { val: 'livestock', label: 'ບ່ອນລ້ຽງສັດນ້ອຍ' },
                { val: 'pond', label: 'ໜອງປາ' },
                { val: 'other', label: 'ຮູບພາບອື່ນໆ' },
            ],
        }
    },
    computed: {
        filteredSchools() {
            if (!this.schoolSearch) return this.schools;
            const q = this.schoolSearch.toLowerCase();
            return this.schools.filter(s => 
                (s.value && s.value.toString().toLowerCase().includes(q)) || 
                (s.text && s.text.toLowerCase().includes(q))
            );
        },
        progress() {
            const done = this.sectionDone.filter(Boolean).length;
            return Math.round((done / this.sections.length) * 100);
        }
    },
    methods: {
        handleScroll() {
            const currentScroll = window.scrollY || document.documentElement.scrollTop;
            const delta = 5; // ໄລຍະຫ່າງຂັ້ນຕ່ຳເພື່ອປ້ອງກັນການ flickering

            // ກໍລະນີເລື່ອນຂຶ້ນສຸດໆ (iOS bounce)
            if (currentScroll < 0) return;

            // ຖ້າເລື່ອນໜ້ອຍກວ່າ delta ໃຫ້ຂ້າມໄປ
            if (Math.abs(this.lastScrollTop - currentScroll) <= delta) return;

            if (currentScroll > this.lastScrollTop && currentScroll > 100) {
                // ເລື່ອນລົງ: ເຊື່ອງ Header (ຫຼັງຈາກເລື່ອນກາຍ 100px)
                this.showHeader = false;
            } else if (currentScroll < this.lastScrollTop) {
                // ເລື່ອນຂຶ້ນ: ສະແດງ Header
                this.showHeader = true;
            }
            this.lastScrollTop = currentScroll;
        },
        openSchoolModal() {
            this.$refs['school-modal'].show();
            if (this.schools.length === 0) {
                this.fetchSchools();
            }
        },
        fetchSchools() {
            const loginData = JSON.parse(localStorage.getItem("Login") || "{}");
            axios.get(this.$store.getters.getBaseUrl + "/getItems/v_schools/school_name_lao/EMIS_Code", {
                headers: { 'Authorization': 'Bearer ' + loginData.login_hash }
            })
            .then(res => {
                this.schools = res.data;
            })
            .catch(err => console.error("Error fetching schools:", err));
        },
        selectSchool(s) {
            this.meta.schoolCode = s.value;
            this.meta.schoolName = s.text;
            this.saveDraft(); // ບັນທຶກ Draft ທັນທີເມື່ອເລືອກໂຮງຮຽນ
            this.$refs['school-modal'].hide();
        },
        goSection(idx) { this.currentSection = idx;
            window.scrollTo({ top: 0, behavior: 'smooth' }); },
        nextSection() {
            this.$set(this.sectionDone, this.currentSection, true);
            if (this.currentSection < this.sections.length - 1) {
                this.currentSection++;
                this.saveDraft();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        prevSection() {
            if (this.currentSection > 0) { this.currentSection--;
                window.scrollTo({ top: 0, behavior: 'smooth' }); }
        },
        saveDraft() {
            try {
                localStorage.setItem('cca_draft', JSON.stringify({
                    meta: this.meta,
                    form: this.form,
                    photos: this.photos,
                    currentSection: this.currentSection,
                    sectionDone: this.sectionDone
                }));
                this.showToast('💾 ບັນທຶກ Draft ສຳເລັດ!', 'success');
            } catch (e) { this.showToast('ບໍ່ສາມາດບັນທຶກໄດ້', 'error'); }
        },
        async submitForm() {
            const result = await Swal.fire({
                title: 'ຢືນຢັນການສົ່ງ?',
                text: "ທ່ານຕ້ອງການສົ່ງຂໍ້ມູນການປະເມີນນີ້ແທ້ບໍ່?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'ສົ່ງຂໍ້ມູນ',
                cancelButtonText: 'ຍົກເລີກ'
            });

            if (result.isConfirmed) {
                try {
                    const loginData = JSON.parse(localStorage.getItem("Login") || "{}");
                    const payload = {
                        table: 'CCA_Assessments',
                        data: {
                            ...this.meta,
                            ...this.form,
                            photos: this.photos,
                            timestamp: new Date().toISOString()
                        }
                    };

                    await axios.post(this.$store.getters.getBaseUrl + "/insertOne", payload, {
                        headers: { 'Authorization': 'Bearer ' + loginData.login_hash }
                    });

                    this.$set(this.sectionDone, this.currentSection, true);
                    this.showToast('✅ ສົ່ງຂໍ້ມູນສຳເລັດ!', 'success');
                    localStorage.removeItem('cca_draft');
                    setTimeout(() => { this.submitted = true; }, 800);
                } catch (error) {
                    console.error("Submission failed:", error);
                    this.showToast('❌ ບໍ່ສາມາດສົ່ງຂໍ້ມູນໄດ້. ກະລຸນາລອງໃໝ່.', 'error');
                }
            }
        },
        showToast(msg, type = 'success') {
            const id = Date.now();
            this.toasts.push({ id, msg, type });
            setTimeout(() => { this.toasts = this.toasts.filter(t => t.id !== id); }, 3500);
        },
        triggerFile(key, num) { document.getElementById('ph_' + key + '_' + num).click(); },
        handlePhoto(e, key, num) {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.$set(this.photos, key + '_' + num, event.target.result);
                    this.saveDraft();
                };
                reader.readAsDataURL(file);
            }
        },
        resetForm() {
            Swal.fire({
                title: 'ເລີ່ມໃໝ່?',
                text: "ຂໍ້ມູນທັງໝົດຈະຖືກລ້າງອອກ",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'ຢືນຢັນ'
            }).then((r) => {
                if (r.isConfirmed) {
                    localStorage.removeItem('cca_draft');
                    location.reload();
                }
            });
        },
        loadDraft() {
            try {
                const d = localStorage.getItem('cca_draft');
                if (d) {
                    const p = JSON.parse(d);
                    this.meta = p.meta;
                    this.form = p.form;
                    this.photos = p.photos || {};
                    this.currentSection = p.currentSection || 0;
                    this.sectionDone = p.sectionDone || this.sectionDone;
                    this.showToast('📂 ໂຫຼດ Draft ສຳເລັດ!', 'success');
                }
            } catch (e) { /* ບໍ່ມີການຈັດການ Error ທີ່ນີ້, ພຽງແຕ່ບໍ່ໃຫ້ Program Crash */ }
        }
    },
    mounted() {
        this.loadDraft();
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style>
*, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

:root {
    --primary: #1e3a5f;
    --primary-light: #2d6a9f;
    --primary-dark: #152d4a;
    --primary-lighter: #ebf4ff;
    --accent: #f5821f;
    --accent-light: #fff3e8;
    --success: #16a34a;
    --success-light: #dcfce7;
    --danger: #dc2626;
    --danger-light: #fee2e2;
    --bg: #f4f6fa;
    --card: #ffffff;
    --border: #e2e8f0;
    --border-light: #f1f5f9;
    --text: #1e293b;
    --text-muted: #64748b;
    --text-light: #94a3b8;
    --shadow-sm: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);
    --shadow: 0 4px 12px rgba(30,58,95,0.08);
    --shadow-md: 0 8px 24px rgba(30,58,95,0.10);
    --shadow-lg: 0 16px 40px rgba(30,58,95,0.14);
    --radius: 12px;
    --radius-sm: 8px;
    --radius-xs: 6px;
}

body {
    font-family: 'Noto Sans Lao', 'Inter', 'IBM Plex Sans', sans-serif;
    background: var(--bg);
    color: var(--text);
    min-height: 100vh;
    font-size: 14.5px;
    line-height: 1.65;
    -webkit-font-smoothing: antialiased;
}

/* ====== HEADER ====== */

.app-header {
    background: linear-gradient(160deg, var(--primary) 0%, var(--primary-dark) 100%);
    color: #fff;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 20px rgba(0,0,0,0.20);
    transition: transform 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease;
}

.header-hidden {
    transform: translateY(-100%);
    opacity: 0;
    pointer-events: none;
}

.header-top {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 13px 24px 11px;
    border-bottom: 1px solid rgba(255,255,255,0.10);
}

.header-logo {
    width: 40px;
    height: 40px;
    background: rgba(255,255,255,0.15);
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}

.header-title h1 {
    font-size: 14.5px;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.3;
}

.header-title p {
    font-size: 11px;
    opacity: 0.60;
    margin-top: 2px;
}

.header-meta {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    padding: 10px 24px 13px;
}

.meta-field {
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.13);
    border-radius: var(--radius-xs);
    padding: 6px 11px;
    font-size: 12px;
    flex: 1;
    min-width: 155px;
    transition: background 0.2s;
}

.meta-field.clickable {
    cursor: pointer;
}

.meta-field.clickable:hover,
.meta-field:focus-within {
    background: rgba(255,255,255,0.16);
    border-color: rgba(255,255,255,0.28);
}

.meta-field label {
    opacity: 0.65;
    white-space: nowrap;
    font-weight: 500;
    font-size: 11px;
    letter-spacing: 0.02em;
}

.meta-field input {
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-family: inherit;
    font-size: 12.5px;
    font-weight: 600;
    width: 100%;
    min-width: 70px;
}

.meta-field input::placeholder {
    opacity: 0.38;
    color: #fff;
    font-weight: 400;
}

/* ====== HEADER TOGGLE ====== */

.header-toggle {
    position: fixed;
    top: 12px;
    right: 16px;
    z-index: 1001;
    width: 32px;
    height: 32px;
    background: rgba(255,255,255,0.15);
    backdrop-filter: blur(8px);
    color: #fff;
    border: 1px solid rgba(255,255,255,0.25);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.25s cubic-bezier(0.4,0,0.2,1);
    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
}

.header-toggle.is-hidden {
    background: var(--primary);
    border-color: var(--primary-light);
    box-shadow: 0 4px 14px rgba(0,0,0,0.22);
}

.header-toggle:hover { transform: scale(1.1); }
.header-toggle:active { transform: scale(0.92); }

/* ====== PROGRESS ====== */

.progress-bar-wrap {
    background: var(--card);
    padding: 9px 24px;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: center;
    gap: 12px;
}

.progress-label {
    font-size: 11.5px;
    color: var(--text-muted);
    white-space: nowrap;
    font-weight: 500;
}

.progress-track {
    flex: 1;
    height: 5px;
    background: var(--border);
    border-radius: 99px;
    overflow: hidden;
}

.progress-fill {
    height: 100%;
    border-radius: 99px;
    background: linear-gradient(90deg, var(--primary-light), var(--accent));
    transition: width 0.5s cubic-bezier(0.4,0,0.2,1);
}

.progress-pct {
    font-size: 12px;
    font-weight: 700;
    color: var(--primary);
    min-width: 34px;
    text-align: right;
}

/* ====== NAV TABS ====== */

.nav-scroll-wrapper {
    background: var(--card);
    position: sticky;
    top: 155px;
    z-index: 90;
    border-bottom: 1px solid var(--border);
    transition: top 0.3s ease;
}

.nav-scroll-wrapper.tabs-at-top {
    top: 0 !important;
}

.section-nav {
    display: flex;
    overflow-x: auto;
    gap: 0;
    padding: 0 20px;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.section-nav::-webkit-scrollbar { display: none; }

.nav-tab {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 11px 13px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 500;
    color: var(--text-muted);
    transition: all 0.2s ease;
    flex-shrink: 0;
    margin-bottom: -1px;
    border-top: none;
    border-left: none;
    border-right: none;
    background: none;
}

.nav-tab:hover { color: var(--primary-light); }

.nav-tab .tab-num {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 700;
    background: var(--border);
    color: var(--text-muted);
    transition: all 0.2s;
    flex-shrink: 0;
}

.nav-tab.active { color: var(--primary); border-bottom-color: var(--primary); }
.nav-tab.active .tab-num { background: var(--primary); color: #fff; }
.nav-tab.done .tab-num { background: var(--success); color: #fff; }
.nav-tab.done { color: var(--success); }

/* MODAL STYLES */
.meta-field.clickable { cursor: pointer; }
.custom-modal-table { font-size: 13.5px; }

/* ====== MAIN LAYOUT ====== */

.main {
    max-width: 820px;
    margin: 0 auto;
    padding: 28px 16px 100px;
}

/* ====== SECTION CARD ====== */

.section-card {
    background: var(--card);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    overflow: hidden;
    border: 1px solid var(--border);
}

.section-card.active-section {
    animation: fadeInUp 0.35s ease both;
}

@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0); }
}

.section-header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 24px;
    color: #fff;
}

.section-icon {
    width: 44px;
    height: 44px;
    background: rgba(255,255,255,0.16);
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}

.section-title-wrap h2 {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -0.01em;
}

.section-title-wrap p {
    font-size: 11.5px;
    opacity: 0.72;
    margin-top: 2px;
}

.section-body {
    padding: 24px;
}

/* ====== QUESTION ====== */

.question-block {
    padding: 18px 0;
    border-bottom: 1px solid var(--border-light);
}

.question-block:first-child { padding-top: 0; }

.question-block:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.q-label {
    font-size: 14px;
    font-weight: 600;
    color: var(--text);
    margin-bottom: 12px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    line-height: 1.55;
}

.q-num {
    background: var(--primary-lighter);
    color: var(--primary-light);
    font-size: 10.5px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 4px;
    white-space: nowrap;
    flex-shrink: 0;
    margin-top: 2px;
    letter-spacing: 0.02em;
}

.q-note {
    font-size: 12px;
    color: var(--text-muted);
    background: var(--border-light);
    border-left: 3px solid var(--border);
    padding: 8px 12px;
    border-radius: 0 var(--radius-xs) var(--radius-xs) 0;
    margin-bottom: 12px;
}

.q-note.warn {
    background: var(--accent-light);
    border-color: var(--accent);
    color: #92400e;
}

/* ====== INPUT STYLES ====== */

.form-input,
.form-select,
.form-textarea {
    width: 100%;
    padding: 9px 13px;
    border: 1.5px solid var(--border);
    border-radius: var(--radius-sm);
    font-family: inherit;
    font-size: 14px;
    color: var(--text);
    background: #fff;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
    border-color: var(--primary-light);
    box-shadow: 0 0 0 3px var(--primary-lighter);
}

.form-textarea {
    resize: vertical;
    min-height: 84px;
    line-height: 1.6;
}

.form-input-sm {
    width: auto;
    min-width: 130px;
    display: inline-block;
}

.input-row {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    align-items: flex-end;
}

.input-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
    min-width: 160px;
}

.input-group label {
    font-size: 12px;
    color: var(--text-muted);
    font-weight: 500;
}

/* ====== RADIO / CHECKBOX ====== */

.options-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.options-list.inline-2 {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
}

.opt-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 14px;
    border-radius: var(--radius-sm);
    border: 1.5px solid var(--border);
    cursor: pointer;
    transition: all 0.15s ease;
    background: #fff;
    font-size: 13.5px;
    color: var(--text);
}

.opt-item:hover {
    border-color: var(--primary-light);
    background: var(--primary-lighter);
    color: var(--primary);
}

.opt-item.selected-radio {
    border-color: var(--primary-light);
    background: var(--primary-lighter);
    color: var(--primary);
    font-weight: 500;
}

.opt-item.selected-check {
    border-color: var(--success);
    background: var(--success-light);
    color: var(--success);
    font-weight: 500;
}

.opt-item input[type=radio],
.opt-item input[type=checkbox] {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
    margin-top: 3px;
    accent-color: var(--primary);
    cursor: pointer;
}

.opt-item input[type=checkbox] {
    accent-color: var(--success);
}

.opt-text {
    flex: 1;
    line-height: 1.5;
}

.opt-sub {
    display: flex;
    align-items: center;
    gap: 7px;
    margin-top: 8px;
    flex-wrap: wrap;
}

.opt-sub input { width: 180px; }

/* ====== MONTH GRID ====== */

.month-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 6px;
}

.month-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 10px;
    border-radius: var(--radius-xs);
    border: 1.5px solid var(--border);
    cursor: pointer;
    font-size: 12.5px;
    transition: all 0.15s;
    background: #fff;
    color: var(--text);
}

.month-item:hover {
    border-color: var(--success);
    background: var(--success-light);
    color: var(--success);
}

.month-item.selected {
    border-color: var(--success);
    background: var(--success-light);
    font-weight: 600;
    color: var(--success);
}

.month-item input { accent-color: var(--success); }

/* ====== CONSENT SECTION ====== */

.consent-box {
    background: linear-gradient(135deg, #f0f7ff, #f0fdf4);
    border: 1.5px solid #bfdbfe;
    border-radius: var(--radius-sm);
    padding: 20px;
    margin-bottom: 20px;
}

.consent-box h3 {
    font-size: 14px;
    color: var(--primary);
    margin-bottom: 10px;
    font-weight: 700;
}

.consent-box p {
    font-size: 13px;
    color: var(--text-muted);
    line-height: 1.75;
}

/* ====== BADGES ====== */

.badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 99px;
    font-size: 10.5px;
    font-weight: 600;
    letter-spacing: 0.02em;
}

.badge-success { background: var(--success-light); color: var(--success); }
.badge-warn    { background: var(--accent-light); color: var(--accent); }
.badge-info    { background: var(--primary-lighter); color: var(--primary-light); }

/* ====== BUTTONS ====== */

.btn-row {
    display: flex;
    gap: 10px;
    margin-top: 32px;
    flex-wrap: wrap;
    align-items: center;
}

.btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 22px;
    border-radius: var(--radius-sm);
    font-family: inherit;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.2s cubic-bezier(0.4,0,0.2,1);
    letter-spacing: 0.01em;
}

.btn-primary {
    background: var(--primary);
    color: #fff;
    box-shadow: 0 2px 8px rgba(30,58,95,0.25);
}

.btn-primary:hover {
    background: var(--primary-light);
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(30,58,95,0.30);
}

.btn-secondary {
    background: #fff;
    color: var(--text);
    border: 1.5px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.btn-secondary:hover {
    background: var(--border-light);
    border-color: #cbd5e1;
}

.btn-success {
    background: var(--success);
    color: #fff;
    box-shadow: 0 2px 8px rgba(22,163,74,0.25);
}

.btn-success:hover {
    background: #15803d;
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(22,163,74,0.30);
}

.btn-sm { padding: 6px 14px; font-size: 12.5px; }

/* ====== PHOTO SECTION ====== */

.photo-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.photo-slot {
    border: 2px dashed var(--border);
    border-radius: var(--radius-sm);
    padding: 18px 12px;
    text-align: center;
    background: #fafcfe;
    min-height: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: border-color 0.2s, background 0.2s;
}

.photo-slot:hover {
    border-color: var(--primary-light);
    background: var(--primary-lighter);
}

.photo-slot .photo-icon { font-size: 26px; opacity: 0.32; }

.photo-slot .photo-label {
    font-size: 12.5px;
    font-weight: 600;
    color: var(--text);
}

.photo-preview-img {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: var(--radius-xs);
    margin-top: 6px;
    border: 1px solid var(--border);
}

/* ====== SUMMARY ====== */

.summary-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    border-radius: var(--radius-sm);
    overflow: hidden;
    border: 1px solid var(--border);
}

.summary-table th,
.summary-table td {
    padding: 10px 14px;
    text-align: left;
    border-bottom: 1px solid var(--border);
}

.summary-table th {
    background: var(--primary-lighter);
    color: var(--primary);
    font-weight: 600;
    font-size: 11.5px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.summary-table tr:last-child td { border-bottom: none; }

.summary-table tr:nth-child(even) td { background: #f9fbfd; }

/* ====== TOAST ====== */

.toast-wrap {
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;
}

.toast {
    background: var(--card);
    border-radius: var(--radius-sm);
    box-shadow: var(--shadow-md);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13.5px;
    min-width: 230px;
    max-width: 320px;
    border-left: 3px solid var(--success);
    animation: slideIn 0.3s cubic-bezier(0.4,0,0.2,1);
    pointer-events: auto;
}

.toast.error { border-left-color: var(--danger); }
.toast-icon { font-size: 16px; }

.toast-msg {
    flex: 1;
    font-weight: 500;
    color: var(--text);
}

@keyframes slideIn {
    from { transform: translateX(40px); opacity: 0; }
    to   { transform: translateX(0); opacity: 1; }
}

/* ====== MISC ====== */

.skip-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: var(--accent);
    background: var(--accent-light);
    border-radius: 4px;
    padding: 2px 7px;
    margin-left: 8px;
    font-weight: 600;
}

.divider {
    height: 1px;
    background: var(--border);
    margin: 16px 0;
}

/* ====== SUBMITTED ====== */

.submitted-box {
    text-align: center;
    padding: 64px 24px;
}

.submitted-icon {
    font-size: 72px;
    margin-bottom: 20px;
}

.submitted-box h2 {
    font-size: 22px;
    font-weight: 700;
    color: var(--success);
    margin-bottom: 10px;
}

.submitted-box p {
    color: var(--text-muted);
    font-size: 14.5px;
}

/* ====== RESPONSIVE ====== */

@media (max-width: 600px) {
    .header-top { padding: 10px 14px 9px; }
    .header-meta { padding: 8px 14px 11px; gap: 5px; }
    .meta-field { min-width: 130px; }
    .section-body { padding: 16px; }
    .month-grid { grid-template-columns: repeat(3, 1fr); }
    .photo-grid { grid-template-columns: 1fr; }
    .section-nav { padding: 0 12px; }
    .main { padding: 16px 10px 100px; }
    .btn-row { gap: 8px; }
}
</style>